export default function wbsExcerpts(
    {
        sections = null,
        excerpt = null,
        expandButton = null,
        full = null,
    } = {}) {

    if (!sections) return;

    const items = document.querySelectorAll(sections);


    if (items.length > 0) {
        items.forEach((item) => {
            const excerptEl = item.querySelector(excerpt);
            const expandButtonEl = item.querySelector(expandButton);
            const fullEl = item.querySelector(full);


            if (!excerptEl || !expandButtonEl || !fullEl) return;


            expandButtonEl.addEventListener('click', () => {
                excerptEl.classList.add('hidden');
                fullEl.classList.remove('hidden');
                expandButtonEl.classList.add('hidden');
            });
        });
    }
}

